import React from 'react';
import CSSclasses from './Spinner.module.css'

const spinner = () => (
  <div className={CSSclasses.Loader}>Loading...</div>
);

export default spinner;
